const SESSION_TYPE_COLORS = [
  {
    id: "neutral-beige",
    value: "#FFF3E7",
    disabledValue: "#FEF9F2",
    name: "Vanilla",
  },
  {
    id: "blue-green",
    value: "#C0F7EA",
    disabledValue: "#DFF8F2",
    name: "Beach",
  },
  {
    id: "light-orange",
    value: "#FFDCCC",
    disabledValue: "#FBE9E1",
    name: "Papaya",
  },
  {
    id: "yellow",
    value: "#FFECA6",
    disabledValue: "#FCF3CE",
    name: "Dandelion",
  },
  {
    id: "light-purple",
    value: "#E7DFFF",
    disabledValue: "#EFEBFD",
    name: "Lavender",
  },
  {
    id: "light-blue",
    value: "#CDE9FD",
    disabledValue: "#E3F1FB",
    name: "Aquarius",
  },
  {
    id: "baby-pink",
    value: "#FFE1F2",
    disabledValue: "#FBECF6",
    name: "Blossom",
  },
  {
    id: "light-khaki",
    value: "#C2F5B9",
    disabledValue: "#DFF6D8",
    name: "Lime",
  },
];

export default SESSION_TYPE_COLORS;
